import { Component, OnInit } from '@angular/core';

import { NotificationsService } from 'angular2-notifications';
import { DPUserService } from '../../../portalv1/dp-user.service';
import { DPSubscriptionService } from '../../../portalv1';
import { DPAccountService } from '../../../portalv1/dp-accounts.service';
import { ToasterService } from 'angular2-toaster';


@Component({
  selector: 'app-customer-hub',
  templateUrl: './customer-hub.component.html',
  styleUrls: ['./customer-hub.component.scss']
})
export class CustomerHubComponent implements OnInit {
  SETTING_TYPE = 'request';
  busyLoading = false;
  accounts: any = [];
  requestTypes = [
    {
      label: 'All',
      name: ''
    },
    {
      label: 'Shows',
      name: 'shows'
    },
    {
      label: 'Markets',
      name: 'markets'
    },
    {
      label: 'Modules',
      name: 'modules'
    }];
  selectedAccount;
  selectedRequestType;
  requests;
  currentRequests;

  constructor( private toasterService: ToasterService,
               public accountService: DPAccountService,
               public userService: DPUserService,
               public subscriptionService: DPSubscriptionService ) { }

  ngOnInit() {
    this.selectedRequestType = this.requestTypes[0];

    this.getCustomerAccounts();
  }

  getCustomerAccounts(): any {
    this.busyLoading = true;
    this.accountService.getSubscriptionUserAccounts().then(res => {
      if (!res || !res.user_accounts) {
          this.toasterService.pop('error', 'Catalog', 'Failed to load list of customers');
          return;
      }
      const accounts = [];
      res.user_accounts.forEach(($account, index) => {
          const rowData: any = {};
          rowData.id = $account.account_id;
          rowData.name = $account.account_name;
          rowData.customer = $account.customer;
          rowData.status = $account.status;
          rowData.access_level = $account.access_level;
          accounts.push(rowData);
      });
      this.accounts = accounts;

      if ( this.accounts && this.accounts.length > 0 ) {
        this.selectedAccount = this.accounts[0];
      }

      if ( this.selectedAccount ) {
        this.getAllRequest( this.selectedAccount );
      }
    });
  }

  getAllRequest(selectedAccount: any): any {
    this.accountService.getUserSetting( this.SETTING_TYPE ).then(res => {
      if (!res || !res.settings) {
        this.toasterService.pop('error', 'Catalog', 'No request is available');
        return;
      }
      this.requests = res.settings;

      this.filterByAccount( this.selectedAccount );
    });
  }

  filterByAccount( account ) {
    this.busyLoading = true;
    this.selectedAccount = account;
    // this.currentRequests = this.requests;

    this.userService.getUsers( account.id ).then(res => {
      if (!res || !res.user) {
        this.toasterService.pop('error', 'Catalog', 'No request is available');
        return;
      }

      const requests = [];
      this.requests.forEach(request => {
        res.user.forEach(user => {
          if ( request.user_id == user.user_id ) {
            request.user_name = user.first_name + ' ' + user.last_name;
            requests.push( request );
          }
        });
      });
      this.currentRequests = requests;

      // this.currentRequests  = this.requests.filter(function(array_el){
      //   return res.user.filter(function(anotherOne_el){
      //       return anotherOne_el.user_id == array_el.user_id;
      //   }).length != 0
      // });

      this.busyLoading = false;
    });
  }

  filterByType( type ) {
    this.selectedRequestType = type;
  }

}



// WEBPACK FOOTER //
// ./src/app/portalv1/components/customer-hub/customer-hub.component.ts